import React from 'react';
import MenuButton from '../../../../../Common/MenuButton/MenuButton';
import MenuPage from '../../../../../Common/Navigation/MenuPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faFileSignature, faCogs } from '@fortawesome/free-solid-svg-icons';

const Menu = ({ handleActiveModal, title }) => {
	return (
        <MenuPage title="Markers">
			<MenuButton
				title="Appointee Contract Response Data"
				icon={() => <FontAwesomeIcon icon={faFileSignature} size="9x" />}
				width="80%"
				onClick={() => handleActiveModal('appointeeContractResponseData')}
			/>
        </MenuPage>
	);
};

export default Menu;
